<div #gridContainer class="grid">
  <div appEnclosureBorder [reference]="configurationGrid" [ngClass]="{'floor-standing': enclosure?.configurationType === 'floorStanding'}" class="enclosure-border position-absolute {{ enclosure?.configurationIp }} sh{{ enclosure?.socleHeight }}"></div>
  <app-prisma-xs-widget-grid
    [columns]="maxFields"
    [rows]="maxRows"
    [showGrid]="false"
    (widgetPositionChange)="resizeEnclosure($event)">
    <app-prisma-xs-widget class="d-flex"
      [minRows]="minRows"
      [minColumns]="minFields"
      [position]="enclosurePosition"
      [isMaxRows]="enclosure?.configurationRows === maxRows"
      [isMaxFields]="enclosure?.configurationFields === maxFields"
      [movable]="false"
      [resizable]="isEditableProject"
      [outsideBorder]="true"
      [resizeOutside]="true"
      [resizeDirections]="enclosureResizeDirections">
      <div class="enclosure-grid widget-grid-content" #configurationGrid>
        <div class="enclosure-frame-1 outer-frame">
          <div class="enclosure-frame-2 inner-frame">
            <div #enclosureHolder class="enclosure-frame-3">
              @for (upright of arrayOfUprights; track upright) {
                <div appUprights
                  [upright]="upright"
                  [zoomLevel]="zoomLevel"
                  [enclosure]="enclosure"
                [parentDiv]="enclosureHolder"></div>
              }
              <app-prisma-xs-enclosure-grid
                #enclosureGridComponent
                [showGrid]="showGrid"
                [showCovers]="showCovers"
                [zoomLevel]="zoomLevel"
                [allArticles]="allArticles"
                [rows]="rows"
                [cols]="cols"
                [widgets]="widgets"
                [placedKits]="placedKits"
                [contextMenuActionType]="contextMenuActionType"
                [articleCopied]="articleCopied"
                [availablePlacingGrabbingArticleOnGrid]="availablePlacingGrabbingArticleOnGrid"
                [isEditableProject]="isEditableProject"
                [dropArea]="dropArea"
                (selectWidget)="onSelectWidget($event)"
                (changeWidgetPosition)="onWidgetPositionChange($event)"
                (list)="emitGridList($event)"
                (enterGrid)="enterOnGrid()"
                (gridLeave)="leaveGrid()"
                (contextMenuData)="contextMenu($event)"
                (contextMenuActionData)="contextMenuAction($event)"
              ></app-prisma-xs-enclosure-grid>
            </div>
          </div>
        </div>
      </div>
    </app-prisma-xs-widget>
  </app-prisma-xs-widget-grid>
</div>

